import Services from "../services/Services";

export default {
	install(Vue) {
		Vue.prototype.$httpServices = Services;
	}
};
